import { DefaultDialogDom, IDialogController, IDialogDom } from "@aurelia/dialog";
import { IFormInputOption } from "@components/form/interfaces/form-interface";
import { inject, resolve } from "aurelia";
import { CurrentFile, IStep } from "../../brand-guide-page";

@inject(IDialogDom)
export class PostExampleDrawerComponent {

  $dialog: IDialogController;

  private brandName: string
  private brandSegment: IFormInputOption
  // private brandSegmentValue: string
  private backgroundColor: string
  private accentColor: string
  private foregroundColor: string
  private postDescription: string
  private currentFile: CurrentFile
  private logoFileId: string
  private currentStep: number
  private steps: IStep[]
  private mainProgressBarValue: number
  private saveBrandFunction: () => Promise<void>

  host: Element = resolve(Element);

  constructor(private dialogDom: DefaultDialogDom) {
  }

  activate(model: {
    brandName: string,
    // brandSegmentValue: string,
    brandSegment: IFormInputOption,
    backgroundColor: string,
    accentColor: string,
    foregroundColor: string,
    postDescription: string,
    currentFile: CurrentFile,
    logoFileId: string,
    currentStep: number,
    steps: IStep[],
    mainProgressBarValue: number,
    saveBrandFunction: () => Promise<void>
  }) {
    this.brandName = model.brandName;
    this.brandSegment = model.brandSegment;
    this.backgroundColor = model.backgroundColor;
    this.accentColor = model.accentColor;
    this.foregroundColor = model.foregroundColor;
    this.postDescription = model.postDescription;
    this.currentFile = model.currentFile;
    this.logoFileId = model.logoFileId;
    this.currentStep = model.currentStep;
    this.steps = model.steps;
    this.mainProgressBarValue = model.mainProgressBarValue;
    this.saveBrandFunction = model.saveBrandFunction;
  };

  async saveBrand() {

    await this.saveBrandFunction()

    this.$dialog.ok();
  }

  attaching() {
    const anim = this.host.animate(
      [
        { transform: 'translateX(100%)' },
        { transform: 'translateX(0)' }
      ],
      { duration: 300, easing: 'ease-out' }
    );
    return anim.finished;
  }

  detaching() {
    const anim = this.host.animate(
      [
        { transform: 'translateX(0)' },
        { transform: 'translateX(100%)' }
      ],
      { duration: 300, easing: 'ease-in' }
    );
    return anim.finished;
  }

}